<div class="flex column gap-16 align-items-center full-width">
  <app-step-indicator
    [currentStep]="currentIndex()"
    [maxSteps]="totalSteps()"
  />

  @switch (importStep()) {
    @case (ImportExistingStep.IMPORT_SWTICH) {
      <div class="full-width" [@stepAnimation]="slideDirection()">
        <app-import-switch-import-existing-step (next)="next()" />
      </div>
    }
    @case (ImportExistingStep.ENTER_SEED_PHRASE) {
      <div class="full-width" [@stepAnimation]="slideDirection()">
        <app-seed-phrase-import-existing-step
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
    @case (ImportExistingStep.SEED_PASSPHRASE) {
      <div class="full-width" [@stepAnimation]="slideDirection()">
        <app-seed-passphrase-import-existing-step
          (next)="next()"
          (previous)="previous()"
          [skipPassword]="skipPassword()"
        />
      </div>
    }
    @case (ImportExistingStep.ENTER_PRIVATE_KEY) {
      <div class="full-width" [@stepAnimation]="slideDirection()">
        <app-private-key-import-existing-step
          (next)="next()"
          (previous)="previous()"
          [skipPassword]="skipPassword()"
        />
      </div>
    }
    @case (ImportExistingStep.IMPORT_BACKUP) {
      <div class="full-width" [@stepAnimation]="slideDirection()">
        <app-backup-import-existing-step
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
    @case (ImportExistingStep.CREATE_PIN) {
      <div class="full-width" [@stepAnimation]="slideDirection()">
        <app-create-pin-import-existing-step
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
    @case (ImportExistingStep.SUCCESS) {
      <div class="full-width" [@stepAnimation]="slideDirection()">
        <app-success-import-existing-step
          (next)="next()"
          (previous)="previous()"
        />
      </div>
    }
  }
</div>
